// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Daily Summary — light scoped polish, matches Accounts */

.summary-page {
  margin-top: 67px;
  padding: 0 16px 20px;
  box-sizing: border-box;
}

.summary-page .summaryToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 12px;
  flex-wrap: nowrap;
}

.summary-page .headS {
  margin: 0;
  color: #0f172a;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.3;
  white-space: nowrap;
  flex-shrink: 0;
}

.summary-page .reports {
  color: #0f172a;
  text-decoration: none;
  font-weight: 700;
  font-size: 24px;
}

.summary-page .reports:hover {
  color: #07a6ef;
}

.summary-page .crumbSep {
  margin: 0 6px;
  color: #94a3b8;
  font-weight: 600;
  font-size: 20px;
}

.summary-page .reporter {
  color: #0f172a;
  font-weight: 700;
  font-size: 24px;
}

.summary-page .summaryFilters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: nowrap;
  margin-left: auto;
}

.summary-page .searchbarrs,
.summary-page .dropdownO {
  width: 150px;
  height: 36px;
  margin: 0;
  padding: 0 10px;
  font-size: 13px;
  color: #0f172a;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
}

.summary-page .uploadSS {
  margin: 0;
}

.summary-page .choose-file-buttonn {
  margin: 0;
  height: 36px;
  width: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #79c6e9 !important;
  border: none !important;
}

.summary-page .orderT {
  width: 100%;
  margin: 8px 0 0;
}

.summary-page .Oth {
  color: #334155;
  font-size: 12px !important;
  font-weight: 700 !important;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb !important;
  padding: 12px 14px !important;
  white-space: nowrap;
}

.summary-page .Otd {
  color: #475569;
  font-size: 13px !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #f1f5f9 !important;
  padding: 12px 14px !important;
}

@media (max-width: 900px) {
  .summary-page .summaryToolbar {
    flex-wrap: wrap;
  }

  .summary-page .summaryFilters {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-left: 0;
  }
}

@media (max-width: 600px) {
  .summary-page {
    margin-top: 50px;
    padding: 0 8px 16px;
  }

  .summary-page .headS,
  .summary-page .reports,
  .summary-page .reporter {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/Summary.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;;IAGE,eAAe;EACjB;AACF","sourcesContent":["/* Daily Summary — light scoped polish, matches Accounts */\r\n\r\n.summary-page {\r\n  margin-top: 67px;\r\n  padding: 0 16px 20px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.summary-page .summaryToolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  margin: 0 0 12px;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.summary-page .headS {\r\n  margin: 0;\r\n  color: #0f172a;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n  line-height: 1.3;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.summary-page .reports {\r\n  color: #0f172a;\r\n  text-decoration: none;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n}\r\n\r\n.summary-page .reports:hover {\r\n  color: #07a6ef;\r\n}\r\n\r\n.summary-page .crumbSep {\r\n  margin: 0 6px;\r\n  color: #94a3b8;\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n}\r\n\r\n.summary-page .reporter {\r\n  color: #0f172a;\r\n  font-weight: 700;\r\n  font-size: 24px;\r\n}\r\n\r\n.summary-page .summaryFilters {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  flex-wrap: nowrap;\r\n  margin-left: auto;\r\n}\r\n\r\n.summary-page .searchbarrs,\r\n.summary-page .dropdownO {\r\n  width: 150px;\r\n  height: 36px;\r\n  margin: 0;\r\n  padding: 0 10px;\r\n  font-size: 13px;\r\n  color: #0f172a;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.summary-page .uploadSS {\r\n  margin: 0;\r\n}\r\n\r\n.summary-page .choose-file-buttonn {\r\n  margin: 0;\r\n  height: 36px;\r\n  width: 40px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 6px;\r\n  background: #79c6e9 !important;\r\n  border: none !important;\r\n}\r\n\r\n.summary-page .orderT {\r\n  width: 100%;\r\n  margin: 8px 0 0;\r\n}\r\n\r\n.summary-page .Oth {\r\n  color: #334155;\r\n  font-size: 12px !important;\r\n  font-weight: 700 !important;\r\n  background: #f8fafc;\r\n  border-bottom: 1px solid #e5e7eb !important;\r\n  padding: 12px 14px !important;\r\n  white-space: nowrap;\r\n}\r\n\r\n.summary-page .Otd {\r\n  color: #475569;\r\n  font-size: 13px !important;\r\n  font-weight: 500 !important;\r\n  border-bottom: 1px solid #f1f5f9 !important;\r\n  padding: 12px 14px !important;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .summary-page .summaryToolbar {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .summary-page .summaryFilters {\r\n    width: 100%;\r\n    justify-content: flex-start;\r\n    flex-wrap: wrap;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .summary-page {\r\n    margin-top: 50px;\r\n    padding: 0 8px 16px;\r\n  }\r\n\r\n  .summary-page .headS,\r\n  .summary-page .reports,\r\n  .summary-page .reporter {\r\n    font-size: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
